import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const StripeProvider = ({ stripePublishableKey, children }) => {
  const stripePromise = loadStripe(stripePublishableKey);

  return <Elements stripe={stripePromise}>{children}</Elements>;
};

export default StripeProvider;
